import { SVGProps } from "react";

export function FailStep({
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}: SVGProps<SVGSVGElement>) {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.926758" y="0.765625" width="18" height="18" rx="9" fill="#F04438" />
            <path d="M13.4268 6.26562L6.42676 13.2656M6.42676 6.26562L13.4268 13.2656" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}
